var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash/get';
var isMobile = window.innerWidth < 600;
export var textLauncherStyles = function (theme, options) {
    if (options === void 0) { options = {}; }
    var size = options.size || (isMobile ? 84 : 104);
    var background = options.backgroundColor || get(theme, 'colors.brand');
    var color = options.textColor || get(theme, 'colors.textOnBrand');
    return {
        textLauncherRoot: __assign(__assign({ height: 'auto', transform: 'none' }, (options.fontFamily ? { fontFamily: options.fontFamily } : {})), (isMobile ? { bottom: '10px' } : {})),
        textLauncherContainer: {
            position: 'relative',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: "".concat(size, "px"),
            minHeight: "".concat(size, "px"),
            padding: '10px 8px',
            gap: '6px',
            background: background,
            color: color,
            borderRadius: options.borderRadius || '12px',
            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.18)',
            textAlign: 'center',
            transition: 'transform 200ms',
            ':hover': {
                transform: 'scale(1.05)',
            },
        },
        textLauncherBody: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '6px',
            transition: 'opacity 200ms',
        },
        textLauncherTitle: {
            fontWeight: 700,
            fontSize: isMobile ? '13px' : '15px',
            lineHeight: 1.1,
            letterSpacing: '0.01em',
            textTransform: options.uppercase === false ? 'none' : 'uppercase',
            hyphens: 'manual',
            overflowWrap: 'break-word',
        },
        textLauncherMessage: {
            fontWeight: 600,
            fontSize: isMobile ? '10px' : '11px',
            lineHeight: 1.2,
            opacity: 0.95,
        },
        textLauncherArrow: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            background: color,
            color: background,
        },
        textLauncherLoading: {
            position: 'absolute',
        },
        closeIcon: {
            top: '-10px !important',
            right: '-10px !important',
        },
    };
};
